import { create } from 'zustand';
import type { CartItem } from './types';

interface PdvState {
  itens: CartItem[];
  observacao: string;
  comandaId: string | null;
  addItem: (item: CartItem) => void;
  updateQuantidade: (uid: string, quantidade: number) => void;
  removeItem: (uid: string) => void;
  setObservacao: (obs: string) => void;
  setComandaId: (id: string | null) => void;
  clear: () => void;
  subtotal: () => number;
  total: () => number;
}

function itemSubtotal(item: CartItem): number {
  const complementosTotal = item.complementos.reduce((acc, c) => acc + c.preco_adicional, 0);
  return Number(((item.preco_base + complementosTotal) * item.quantidade).toFixed(2));
}

export const usePdvStore = create<PdvState>((set, get) => ({
  itens: [],
  observacao: '',
  comandaId: null,

  addItem: (item) => set((state) => ({ itens: [...state.itens, item] })),
  updateQuantidade: (uid, quantidade) =>
    set((state) => ({
      itens: state.itens.map((i) =>
        i.uid === uid ? { ...i, quantidade: Math.max(0.001, quantidade) } : i,
      ),
    })),
  removeItem: (uid) =>
    set((state) => ({ itens: state.itens.filter((i) => i.uid !== uid) })),
  setObservacao: (obs) => set({ observacao: obs }),
  setComandaId: (id) => set({ comandaId: id }),
  clear: () => set({ itens: [], observacao: '', comandaId: null }),

  subtotal: () => get().itens.reduce((acc, i) => acc + itemSubtotal(i), 0),
  total: () => Math.max(get().subtotal(), 0),
}));

export function calcularSubtotal(item: CartItem): number {
  return itemSubtotal(item);
}
